export default __webpack_public_path__ + "static/media/Bg-video-tuner.17a78da9.mp4";